// An UNSENT message: a send the network or the server refused. It lives only in
// this client (the server never saw it), so it is kept out of the `temp-`
// in-flight namespace and carried across every refresh from the server until the
// person retries or discards it. One rule, shared by the stream and the thread.

/** The optimistic `temp-` message, marked unsent (its words kept, its file id kept for a retry). */
export function markUnsent(msg, fileId) {
  return { ...msg, id: 'unsent-' + String(msg.id).replace(/^temp-/, ''), _key: msg.id, _unsent: { fileId: fileId || null } }
}

/** The server's list, with this client's unsent messages (those `keep` admits) back at its foot. */
export function withUnsent(fresh, prev, keep = () => true) {
  const unsent = (prev || []).filter((m) => m?._unsent && keep(m))
  return unsent.length ? [...fresh, ...unsent] : fresh
}
